export enum AppRoutes {

    // Auth...
    register = "/register",
    login = "/login",
    resetPassword = "/resetpassword",
    createNewPassword = "/createNewPassword",

    home = "/",
    profile = "/profile",

    // Sections...
    sections = "/app-settings/brand-sections",
    section = "/app-settings/brand-sections/:id",
    createStoreSection = "/app-settings/brand-sections/create",
    sectionParams = "/app-settings/brand-sections/",

    // Orders...
    orders = "/orders",
    order = "/orders/:id",
    createOrder = "/orders/create",
    orderParams = "/orders/",
    orderActivity = "/orders/activity/:id",

    // Purchased History...
    purchasedHistory = "/purchased-history",
    purchasedHistoryOrder = "/purchased-history/:id",
    purchasedHistoryParams = "/purchased-history/",

    // Delivery Orders...
    deliveryOrders = "/delivery-orders",

    // New Orders...
    // newOrders = "/new-orders",
    // newOrder = "/new-orders/:id",
    // createNewOrder = "/new-orders/create",
    // newOrderParams = "/new-orders/",

    // Orders...
    deposits = "/deposits",
    deposit = "/deposits/:id",
    createDeposit = "/deposits/create",
    depositParams = "/deposits/",

    // Shipments...
    shipments = "/shipments",
    shipment = "/shipments/:id",
    createShipment = "/shipments/create",
    editShipment = "/shipments/edit/:id",
    shipmentsParams = "/shipments/",

    // Layout ...
    layout = "/app-settings/layouts",
    layoutItem = "/app-settings/layouts/:id",
    createLayoutItem = "/app-settings/layouts/create",
    layoutItemParams = "/app-settings/layouts/",

    // Scraping Items...
    scrapingItems = "/app-settings/scraping-items",
    scrapingItem = "/app-settings/scraping-items/:id",
    createScrapingItem = "/app-settings/scraping-items/create",
    scrapingItemParams = "/app-settings/scraping-items/",

    // Order State Groups...
    orderStateGroups = "/app-settings/order-state-groups",

    // Products...
    products = "/app-settings/products",
    product = "/app-settings/products/:id",
    createProduct = "/app-settings/products/create",
    productParams = "/app-settings/products/",

    // Outfits...
    outfits = "/app-settings/outfits",
    outfit = "/app-settings/outfits/:id",
    createOutfit = "/app-settings/outfits/create",
    outfitParams = "/app-settings/outfits/",

    // Categories...
    categories = "/app-settings/sections",
    category = "/app-settings/sections/:id",
    createCategory = "/app-settings/sections/create",
    createSubcategory = "/app-settings/sections/subcategory/create",
    categoryParams = "/app-settings/sections/",
    subcategory = "/app-settings/sections/:categoryId/subcategories/:id",

    // Groups...
    groups = "/app-settings/groups",
    group = "/app-settings/groups/:id",
    createGroup = "/app-settings/groups/create",
    groupParams = "/app-settings/groups/",

    // Customers...
    customers = "/customers",
    customer = "/customers/:id",
    createCustomer = "/customers/create",
    customerParams = "/customers/",
    customerCart = "/customers/:id/customer-cart",

    // Supports...
    supports = "/supports",
    support = "/supports/:id",
    supportParams = "/supports/",

    // Transactions...
    transactions = "/transactions",
    transaction = "/transactions/:id",
    transactionParams = "/transactions/",

    // Driver Transactions 
    driverTransactions = "/driver-transactions",
    driverTransaction = "/driver-transactions/:id",
    driverTransactionParams = "/driver-transactions/",

    // Reports...
    reports = "/reports",
    reportOrders = "/reports/orders",
    reportCompletedOrders = "/reports/completed-orders",
    reportIncome = "/reports/income",
    reportCustomers = "/reports/customers",
    reportDrivers = "/reports/drivers",
    

    // Advertisements...
    advertisements = "/app-settings/advertisements",
    createAd = "/app-settings/advertisements/create",
    advertisement = "/app-settings/advertisements/:id",
    advertisementParams = "/app-settings/advertisements/",

    // Offers...
    offers = "/offers",
    paymentMethodDiscounts = "/offers/payment-method-discounts",
    paymentMethodDiscount = "/offers/payment-method-discount/:id",
    createPaymentMethodDiscount = "/offers/payment-method-discount/create",
    paymentMethodDiscountParams = "/offers/payment-method-discount/",

    promoCodes = "/offers/promo-codes",
    promoCode = "/offers/promo-codes/:id",
    createPromoCode = "/offers/promo-codes/create",
    promoCodeParams = "/offers/promo-codes/",

    cartOffers = "/offers/cart-offers",
    cartOffer = "/offers/cart-offers/:id",
    createCartOffer = "/offers/cart-offers/create",
    cartOfferParams = "/offers/cart-offers/",

    // Notifications...
    notifications = "/notifications",
    createNotification = "/notifications/create",
    notification = "/notifications/:id",
    notificationParams = "/notifications/",

    // Settings...
    settings = "/dashboard-settings",
    appSettings = "/app-settings",
    businessSettings = "/business-settings",
    // Brands (business-facing scraping items)...
        brands = "/business-settings/brands",
        brand = "/business-settings/brands/:id",
        brandParams = "/business-settings/brands/",
    // Shipping rate cards (App Settings tab)...
        shippingRates = "/app-settings/shipping-rates",
        shippingRate = "/app-settings/shipping-rates/:id",
        shippingRateParams = "/app-settings/shipping-rates/",
    socialLinks = "/app-settings/sociallinks",
    security = "/dashboard-settings/security",
    // Payment Methods...
        paymentMethods = "/app-settings/paymentMethods",
        createPaymentMethod = "/app-settings/paymentMethods/create",
        paymentMethod = "/app-settings/paymentMethods/:id",
        paymentMethodParams = "/app-settings/paymentMethods/",
    // Authirizations...
        authorizations = "/dashboard-settings/authorizations",
        createAuthorization = "/dashboard-settings/authorizations/create",
        authorization = "/dashboard-settings/authorizations/:id",
        authorizationParams = "/dashboard-settings/authorizations/",
    // Drivers...
        drivers = "/dashboard-settings/drivers",
        createDriver = "/dashboard-settings/drivers/create",
        driver = "/dashboard-settings/drivers/:id",
        driverParams = "/dashboard-settings/drivers/",
    // Teams...
        teams = "/app-settings/teams",
        createTeam = "/app-settings/teams/create",
        team = "/app-settings/teams/:id",
        teamParams = "/app-settings/teams/",
    // Provinces...
        provinces = "/dashboard-settings/provinces",
        createProvince = "/dashboard-settings/provinces/create",
        province = "/dashboard-settings/provinces/:id",
        provinceParams = "/dashboard-settings/provinces/",
        // Cities based on Provinces...
            cities = "/dashboard-settings/provinces/:provinceId/cities",
    // Cities V2 (addresses-v2 geo model)...
        citiesV2 = "/dashboard-settings/cities",
        geo = "/dashboard-settings/geo",
        mainAreas = "/dashboard-settings/main-areas",
    // Area Assigns
        areaAssigns = "/dashboard-settings/area-assigns",
        areaAssignsCreate = '/dashboard-settings/area-assigns/create',
        areaAssignsDetials = '/dashboard-settings/area-assigns/:id',

    // Try On
        tryOn = "/app-settings/tryon",

    // App Configs (Settings tab inside App Settings)
        appConfigs = "/app-settings/configs",

    // App Driver (coming soon)
        appDriver = "/app-driver",

    // Refunds...
    refunds = "/refunds",
    createRefund = "/refunds/create",
    editRefund = "/refunds/:id",
    
    // Refund Requests...
    refundRequests = "/refund-requests",
    editRefundRequest = "/refund-requests/:id",
    refundRequestDetails = "/refund-requests/details/:id",

    // Complaints...
    complaints = "/complaints",
    complaintReasons = "/complaints/reasons",

    // Warehouses...
    warehouses = "/warehouses",
    createWarehouse = "/warehouses/create",
    editWarehouse = "/warehouses/:id",
    warehouseDetails = "/warehouses/details/:id",
    warehouseParams = "/warehouses/",
    shippingCompanies = "/shipping-companies",

    // Warehouse Ops (Receiving + Sorting)...
    receiving = "/receiving",
    receivingDetails = "/receiving/:id",
    receivingParams = "/receiving/",
    sorting = "/sorting",
    repackaging = "/repackaging",

    // Watcher...
    watcher = "/watcher",
    watcherMessages = "/watcher/messages",
    watcherAutomation = "/watcher/automation",

    // respond.io...
    respondIO = "/respondio",

    // Helpdesk
    helpdesk = "/helpdesk",
    
    // Human Resources — tile home for the ERP people pages
    humanResources = "/human-resources",
    employees = "/human-resources/employees",
    recruitement = "/human-resources/recruitement",

    // Time & Leave — tile home for the ERP time pages
    timeLeave = "/time-leave",
    timeSheet = "/time-leave/timesheet",
    attendance = "/time-leave/attendance",
    timeOff = "/time-leave/timeoff",

    // Management — tile home for the external portals
    management = "/management",
    ERP = "/management/erp",
    PIM = "/management/pim",
    CMS = "/management/cms",
    OMS = "/management/oms",
}

